import axios from "axios";

export const clienteAxiosOctagon = axios.create({
  baseURL: process.env.REACT_APP_CLIENTE_AXIOS_OCTAGON,
});

export const clienteAxiosSaasExternalConector = axios.create({
  baseURL: process.env.REACT_APP_ICDC_SAAS_EXTERNAL_CONNECTOR,
});

export const clienteAxiosSaaS = axios.create({
  baseURL: process.env.REACT_APP_ICDC_SAAS_NOTIFICATIONS,
});

export const clienteAxiosSaaSLog = axios.create({
  baseURL: process.env.REACT_APP_ICDC_SAAS_CATALOGS,
});

export const clienteAxiosAccesorios = axios.create({
  baseURL: process.env.REACT_APP_CLIENTE_AXIOS_ACCESORIOS
});
export const clienteAxiosCollection = axios.create({
  baseURL: process.env.REACT_APP_CLIENTE_AXIOS_COLLECTION
});
